import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Purifier System",
        price: 50,
        disprice: 40,
        stock: 10,
        intro: "Ensure clean and safe drinking water with our advanced Water Purifier technology",
        content: "Ensure clean and safe drinking water with our advanced Purifier System. Designed for home or office use, it delivers pure, great-tasting water with minimal effort.",
        description: "Our Purifier System uses multi-stage filtration including activated carbon and reverse osmosis to eliminate contaminants such as chlorine, bacteria, and heavy metals. It’s built with durable materials and is easy to install on countertops or under sinks. With its sleek design and quiet operation, this purifier is ideal for daily hydration while ensuring your water meets the highest quality standards.",
        category: ["Water Equipment", "Purification System"],
        tags: ["water", "purifier", "system"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Filtration Stages", content: "5-Stage Reverse Osmosis" },
            { id: 2, title: "Material", content: "BPA-Free Plastic, Stainless Steel" },
            { id: 3, title: "Capacity", content: "12 Liters per hour" },
            { id: 4, title: "Power", content: "Electric (120V/60Hz)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Ayesha Malik",
                date: "May 3, 2025",
                rating: 5,
                content: "Water tastes so much better now! Easy to set up and very reliable."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Khan",
                date: "May 7, 2025",
                rating: 4.5,
                content: "Great purifier for the price. I noticed a difference in taste and clarity immediately."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Bottled Water",
        price: 50,
        disprice: 40,
        stock: 7,
        intro: "Ensure clean and safe drinking water with our premium quality Bottled Water supply",
        content: "Enjoy the convenience of clean, refreshing Bottled Water delivered to your doorstep. Ideal for homes, offices, and events.",
        description: "Our Bottled Water is sourced from natural springs and undergoes multi-stage purification to ensure safety and great taste. Each bottle is made from BPA-free plastic and sealed for freshness. Perfect for hydration at work, during travel, or in daily life, our bottled water provides a reliable and hygienic solution for your drinking needs. Available in standard 19-liter sizes and smaller variants for easy handling.",
        category: ["Drinking Supply", "Hydration Gear"],
        tags: ["water", "bottle", "supply"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Bottle Size", content: "19 Liters (Standard)" },
            { id: 2, title: "Material", content: "BPA-Free Food-Grade Plastic" },
            { id: 3, title: "Water Source", content: "Natural Spring" },
            { id: 4, title: "Shelf Life", content: "6 Months (Unopened)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Sarah Iqbal",
                date: "May 10, 2025",
                rating: 5,
                content: "Love the freshness and convenience! We order weekly for our whole office."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Hamza Yousaf",
                date: "May 12, 2025",
                rating: 4,
                content: "Good taste and reliable service. Bottles are sturdy and easy to handle."
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Water Dispenser",
        price: 50,
        disprice: 40,
        stock: 3,
        intro: "Ensure clean and safe drinking water with our user-friendly Water Dispenser system",
        content: "Stay refreshed with our Water Dispenser — a convenient way to access hot or cold drinking water at home or in the office.",
        description: "Our Water Dispenser is designed for efficiency and ease. It supports standard 19-liter bottled water and features both hot and cold dispensing options. Built with food-grade materials and energy-efficient cooling, it’s perfect for keeping your family or team hydrated. The compact design fits easily in kitchens, break rooms, or reception areas, offering quick access to clean water anytime.",
        category: ["Water Equipment", "Hydration Gear"],
        tags: ["water", "dispenser", "hydration"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Dispense Type", content: "Hot & Cold" },
            { id: 2, title: "Bottle Compatibility", content: "Standard 19L Bottles" },
            { id: 3, title: "Material", content: "ABS Plastic & Stainless Steel" },
            { id: 4, title: "Energy Saving", content: "Yes (Eco-Friendly Mode)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Fatima Riaz",
                date: "May 15, 2025",
                rating: 5,
                content: "Very reliable! We love the instant hot water option. Clean and efficient."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Bilal Asghar",
                date: "May 16, 2025",
                rating: 4.5,
                content: "Great dispenser for the price. Perfect for our small office setup."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Water Distiller",
        price: 50,
        disprice: 40,
        stock: 0,
        intro: "Ensure clean and safe drinking water with our high-efficiency Water Distiller unit",
        content: "Produce ultra-pure drinking water at home or the office with our reliable Water Distiller. Ideal for removing minerals, chemicals, and contaminants.",
        description: "The Water Distiller uses a powerful boiling and condensation process to remove impurities such as heavy metals, chlorine, and microorganisms from tap water. Constructed with stainless steel components, it's easy to clean and built for long-lasting performance. Perfect for homes, dental clinics, labs, or anyone seeking maximum purity in their water supply. Includes a glass or BPA-free collection container.",
        category: ["Water Equipment", "Purification System"],
        tags: ["water", "distiller", "system"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Distillation Capacity", content: "4 Liters per Cycle" },
            { id: 2, title: "Material", content: "Stainless Steel + Glass" },
            { id: 3, title: "Power Source", content: "Electric (750W)" },
            { id: 4, title: "Purification Rate", content: "99.9% Contaminant Removal" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Zara Khurram",
                date: "May 18, 2025",
                rating: 5,
                content: "Distilled water has never tasted this clean. It’s perfect for my lab work too."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Umar Siddiqui",
                date: "May 19, 2025",
                rating: 4,
                content: "Great build and performance. A bit slow per cycle, but results are excellent."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Water Filter",
        price: 50,
        disprice: 40,
        stock: 12,
        intro: "Ensure clean and safe drinking water with our multi-stage Water Filter design",
        content: "Upgrade your drinking water with our efficient Water Filter — designed to reduce contaminants and improve taste, right from the tap.",
        description: "Our Water Filter features multi-layer filtration technology to remove chlorine, sediments, rust, and other impurities while preserving essential minerals. It fits standard faucets and is easy to install without tools. Ideal for kitchens, the filter provides fresh, great-tasting water on demand and helps reduce reliance on bottled water. Replaceable cartridges ensure long-term use with minimal maintenance.",
        category: ["Purification System", "Home Essentials"],
        tags: ["water", "filter", "cartridge"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Filter Type", content: "Activated Carbon + Sediment Filter" },
            { id: 2, title: "Installation", content: "Tool-Free Faucet Mount" },
            { id: 3, title: "Filter Life", content: "Up to 3 Months (Depending on Use)" },
            { id: 4, title: "Flow Rate", content: "2 Liters per Minute" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Neha Dar",
                date: "May 21, 2025",
                rating: 4.5,
                content: "Easy to use and really improves water taste. Definitely a money saver!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Jibran Nazeer",
                date: "May 22, 2025",
                rating: 4,
                content: "Good filter for daily use. Installation was a breeze — no tools needed."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Water Bottle",
        price: 50,
        disprice: 40,
        stock: 9,
        intro: "Ensure clean and safe drinking water with our eco-friendly reusable Water Bottle range",
        content: "Stay hydrated on the go with our durable and eco-friendly Water Bottle — perfect for daily use, workouts, or travel.",
        description: "Our Water Bottle is made from BPA-free, food-grade materials and designed for both style and function. It features a leak-proof lid, ergonomic grip, and a wide-mouth opening for easy cleaning and refilling. Whether you’re at the gym, office, or outdoors, this reusable bottle keeps your water fresh and accessible. Available in multiple colors and sizes to suit every lifestyle.",
        category: ["Hydration Gear", "Home Essentials"],
        tags: ["water", "bottle", "hydration"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "BPA-Free Plastic or Stainless Steel" },
            { id: 2, title: "Capacity", content: "750ml / 1L Options" },
            { id: 3, title: "Lid Type", content: "Leak-Proof Flip Cap" },
            { id: 4, title: "Suitable For", content: "Gym, Travel, Daily Use" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Tania Farooq",
                date: "May 25, 2025",
                rating: 5,
                content: "Stylish and super practical. I take it everywhere — gym, car, work!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Mohsin Rauf",
                date: "May 26, 2025",
                rating: 4.5,
                content: "Solid quality and no leaks. Great value for a reusable bottle."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Water Purifier",
        price: 55,
        disprice: 45,
        stock: 2,
        intro: "Ensure clean and safe drinking water with our advanced Purifier System",
        content: "Experience cleaner, healthier water with our compact Water Purifier — engineered for modern homes and small offices.",
        description: "This Water Purifier is designed to eliminate common impurities like bacteria, chlorine, and heavy metals through a multi-layer filtration process. Its compact, space-saving build fits seamlessly into kitchens or under sinks. It improves taste, reduces odors, and protects against waterborne risks. Easy to install and maintain, it’s a smart and safe choice for everyday hydration.",
        category: ["Purification System", "Water Equipment"],
        tags: ["purifier", "system", "filter"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Filtration System", content: "5-Stage UV + Carbon Filter" },
            { id: 2, title: "Installation", content: "Countertop or Under-Sink" },
            { id: 3, title: "Purification Capacity", content: "10 Liters/Hour" },
            { id: 4, title: "Filter Replacement", content: "Every 6 Months (avg. usage)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Sana Rizvi",
                date: "May 28, 2025",
                rating: 4.5,
                content: "Great performance in a small design. Noticeable difference in water clarity and taste."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Noman Javed",
                date: "May 29, 2025",
                rating: 4,
                content: "Compact and effective. Setup was simple and it works quietly."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Bottled Supply",
        price: 50,
        disprice: 40,
        stock: 0,
        intro: "Ensure clean and safe drinking water with our on-demand Bottled Supply delivery service",
        content: "Reliable and ready-to-use Bottled Supply for homes, businesses, and events — clean, mineral-rich hydration delivered when you need it.",
        description: "Our Bottled Supply is ideal for high-demand environments, featuring purified water enhanced with essential minerals. Each bottle is sealed for safety and hygiene, made from food-grade BPA-free plastic, and available in various sizes including 6L, 10L, and 19L. Whether you’re hosting a gathering or restocking for the office, this convenient and refreshing supply ensures you’re never without clean water.",
        category: ["Drinking Supply", "Water Equipment"],
        tags: ["bottle", "supply", "water"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Bottle Sizes", content: "6L, 10L, 19L Options" },
            { id: 2, title: "Material", content: "Food-Grade BPA-Free Plastic" },
            { id: 3, title: "Water Type", content: "Purified + Mineral Enriched" },
            { id: 4, title: "Storage Advice", content: "Keep in Cool, Dry Place" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Kiran Sheikh",
                date: "May 30, 2025",
                rating: 5,
                content: "We use this for all our family gatherings. Clean and always on time!"
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Yasir Mehmood",
                date: "June 1, 2025",
                rating: 4.5,
                content: "Great option for bulk delivery. The bottles are strong and easy to handle."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Dispenser Unit",
        price: 55,
        disprice: 45,
        stock: 18,
        intro: "Ensure clean and safe drinking water with our modern tabletop Dispenser Unit design",
        content: "Effortlessly access hot or cold drinking water with our sleek Dispenser Unit — perfect for homes, offices, and commercial use.",
        description: "The Dispenser Unit features dual temperature controls, giving you instant access to both hot and cold purified water. Designed for use with standard 19-liter water bottles, it includes an energy-saving mode, child-safety lock, and anti-spill mechanism. The compact vertical build fits well in corners or tight spaces. Built with durable, food-safe materials for long-term reliability and hygiene.",
        category: ["Water Equipment", "Home Essentials"],
        tags: ["dispenser", "water", "hydration"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Temperature Modes", content: "Hot & Cold Dispensing" },
            { id: 2, title: "Compatible Bottles", content: "19L Standard Bottled Water" },
            { id: 3, title: "Safety Features", content: "Child Lock, Overheat Protection" },
            { id: 4, title: "Power Usage", content: "Low Power with Eco Mode" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Mehwish Anwar",
                date: "June 2, 2025",
                rating: 5,
                content: "It’s quiet, efficient, and looks great in our office lobby. Highly recommend!"
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Talha Ahmed",
                date: "June 4, 2025",
                rating: 4,
                content: "Solid dispenser — hot water feature is quick and safe. Value for money!"
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Distiller Machine",
        price: 60,
        disprice: 50,
        stock: 10,
        intro: "Ensure clean and safe drinking water with our advanced Distiller Machine for homes",
        content: "Achieve the highest purity in drinking water with our advanced Distiller Machine — ideal for home, lab, or clinical use.",
        description: "The Distiller Machine purifies water through a heating and condensation process that removes bacteria, heavy metals, and dissolved solids. It’s built from stainless steel for durability and includes a glass or BPA-free plastic collection jug. Easy to operate and clean, this unit delivers consistently clean water with every cycle, making it suitable for sensitive applications and high-standard consumption.",
        category: ["Purification System", "Home Essentials"],
        tags: ["distiller", "system", "water"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Distillation Rate", content: "1 Liter per Hour" },
            { id: 2, title: "Build Material", content: "304 Stainless Steel" },
            { id: 3, title: "Container Type", content: "Glass or BPA-Free Plastic" },
            { id: 4, title: "Power Supply", content: "Electric – 750W" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Rida Hussain",
                date: "June 5, 2025",
                rating: 5,
                content: "Perfect for my clinic — clean, consistent, and easy to use. Highly recommended!"
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "Hassan Tariq",
                date: "June 6, 2025",
                rating: 4.5,
                content: "Delivers pure water every time. A must-have if you want full control over water quality."
            }
        ]
    },

];

export default products;